const sortByPeriodo = (left, right) => left.periodo.localeCompare(right.periodo)

const calculateMonthCount = (reportData) => {
  if (!reportData?.fechaDesde || !reportData?.fechaHasta) {
    return 0
  }

  const [fromYear, fromMonth] = reportData.fechaDesde.slice(0, 7).split('-').map(Number)
  const [toYear, toMonth] = reportData.fechaHasta.slice(0, 7).split('-').map(Number)

  return (toYear - fromYear) * 12 + (toMonth - fromMonth) + 1
}

export const shouldRenderGraficosDenuncias = (reportData) => calculateMonthCount(reportData) > 1

export const createEmptyColumnChartResponse = () => ({
  categories: [],
  series: [],
})

export const mapColumnChartResponse = (response, config) => {
  const rows = Array.isArray(response?.data) ? [...response.data].sort(sortByPeriodo) : []

  return {
    categories: rows.map((row) => row.periodo),
    series: config.series.map((seriesConfig) => ({
      name: seriesConfig.name,
      color: seriesConfig.color,
      data: rows.map((row) => Number(row[seriesConfig.key]) || 0),
    })),
  }
}
